<script setup lang="ts">
import { vKey, formNameKey } from '~/lib/interfaces/profile'
import { CUSTOM_IM_ANALYTICS_ERRORS } from '~/lib/models/gtm'

const props = defineProps<{ name?: string }>()

/**
 * Get validation from McForm injected 'v'
 * The props.name will be the same as v-model in the form
 *  @example <input v-model="input.birthDateStr" name="birthDateStr" />
 */
const v = inject(vKey, undefined)
const formName = inject(formNameKey)
const { trackFormError } = useGTM()

const fieldV = computed(() => {
  if (!v || !props.name) return
  return props.name.split('.').reduce((a, b) => a?.[b], v as any)
})

const invalid = computed(() => {
  if (!fieldV.value) return false
  return !!fieldV.value.$error
})

watch(invalid, () => {
  if (invalid.value) {
    setTimeout(() => {
      if (invalid.value) {
        if (fieldV.value.cpfVerified?.$invalid) {
          trackFormError({
            type: 'metadata.cpf',
            code: String(CUSTOM_IM_ANALYTICS_ERRORS.FORM_ERROR),
            formName: 'enrollment',
          })
        } else {
          trackFormError({
            type: props.name ? (props.name === 'cpf' ? 'metadata.cpf' : props.name) : '',
            formName: formName!,
          })
        }
      }
    }, 1000)
  }
})
</script>

<template>
  <div>
    <slot v-bind="{ invalid: fieldV ? fieldV.$error : false }" />
    <VError v-if="fieldV" :v="fieldV" />
  </div>
</template>
